import { Button } from "antd";
import React from "react";

interface SendRequestButtonProps {
  onClick: () => void;
}
const SendRequestButton = ({ onClick }: SendRequestButtonProps) => {
  return (
    <Button onClick={onClick} type="primary">
      Send a Request
    </Button>
  );
};

export default SendRequestButton;
